// extracted by mini-css-extract-plugin
export default {"root":"CreditInquiriesSection_root__kRqcD","questionsContainer":"CreditInquiriesSection_questionsContainer__ucayO","dateField":"CreditInquiriesSection_dateField__Ag5WU"};